import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is kgm3
export const Density: BaseQuantity = {
  id: "001density",
  name: "density",
  type: "numeric",
  value: "",
  symbol: "\u03C1",
  baseUnit: "kg/m\u00b3",
  selectedUnit: "kg/m\u00b3",
  units: [
    { name: "kg/m\u00b3", fromConst: 1, toConst: 1 },
    { name: "kg/l", fromConst: 1 / 1000, toConst: 1000 },
    { name: "g/ml", fromConst: 1 / 10 ** 6, toConst: 10 ** 6 },
  ],
};
